<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection title="Tracking Status" description="Pantau proses penilaian dari realisasi KPI yang sudah Anda ajukan.">
            <div class="text-right">
              <div class="d-flex flex-row gap-3">
                <!-- <FormGroup invalidmsg="Format tahun salah (YYYY)">
                  <InputForm type="number" v-model="year" :isinvalid="!validateField(/^([0-9]{4}|)$/,year)" />
                </FormGroup> -->
                <FormGroup>
                  <select class="form-control form-control--select" v-model="periode_id" @change="changePeriode">
                    <option
                      v-for="item in list_periode"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item?.name|| '-' }}
                    </option>
                  </select>
                </FormGroup>
              </div>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <Cards>
            <p v-if="!tracking_status_data || tracking_status_data?.length === 0" class="text-center p-10 text-lg">Data tidak ditemukan.</p>

            <FieldsetComponent v-else title="KPI Diajukan" :description="tracking_status_data?.[0]?.created_at ? moment(tracking_status_data[0].created_at).lang('id').format('dddd, D MMMM YYYY, HH:mm') : '-'" :isFieldsetRow="true" :center="true">
              <div class="container">
                <!-- <tracking-timeline :items="['Pengajuan KPI','Ditolak Atasan 1', 'Atasan 2']" :success="step_success" :fail="step_fail"></tracking-timeline> -->
                <tracking-timeline :items="status_result" :success="step_success" :fail="step_fail"></tracking-timeline>
              </div>
              <div class="mt-5">
                <div class="box-summary">
                  <h6 class="box-summary__heading">Ringkasan</h6>
                  <div class="box-summary__list"
                        v-for="(item, i) in tracking_status_data"
                        :key="i"
                      >
                      <div class="box-summary__status">
                        <p class="date-time">{{ moment(item?.created_at).lang('id').format('dddd, D MMMM YYYY, HH:mm') }}</p>
                        <span></span>
                        <p>{{ getStatus(item?.status) }}</p>

                      </div>
                      <router-link
                        v-if="(i + 1) === tracking_status_data.length"
                        :to="{ name: 'Tracking Status Detail', params: { periode_id, realization_id: tracking_status_data[tracking_status_data.length - 1].realization, status: tracking_status_data[tracking_status_data.length - 1].status } }"
                      >
                        Lihat Detail
                        <!-- <ArgonButton outline sm>Lihat Detail</ArgonButton> -->
                      </router-link>
                    </div>
                </div>
                <!-- <div class="table-responsive">
                  <table class="w-100">
                    <tbody>
                      <tr
                        v-for="(item, i) in tracking_status_data"
                        :key="i"
                      >
                        <td class="py-4 border-bottom">
                          <div class="d-flex flex-row justify-content-between">
                            <div class="d-flex flex-column gap-2">
                              <span>{{ getStatus(item?.status) }}</span>
                              <span class="text-secondary text-xs">{{ moment(item?.created_at).lang('id').format('dddd, D MMMM YYYY, HH:mm') }}</span>
                            </div>
                            <router-link v-if="(i + 1) === tracking_status_data.length" :to="{ name: 'Tracking Status Detail', params: { id: '9388237874' } }">
                              <ArgonButton outline>Pelajari Alasan Penolakan</ArgonButton>
                            </router-link>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div> -->
              </div>
            </FieldsetComponent>
          </Cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
// import FormGroup from "@/components/FormGroup.vue";
// import EmployeeApi from "@/repository/api/EmployeeApi";
// import Select2 from 'vue3-select2-component';
import FieldsetComponent from "@/components/FieldsetComponent.vue";
// import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import TrackingTimeline from '@/components/trackingtimeline';
import FormGroup from "@/components/FormGroup.vue";
// import InputForm from "../../../components/InputForm.vue";

import TrackingKpiApi from '@/repository/api/TrackingKpiApi'
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import moment from 'moment';

export default {
  name: "realisasi-target",
  data() {
    return {
      year: new Date().getFullYear(),
      tracking_status_data: null,
      status_result: [],
      step_success: [],
      step_fail: [],
      employee_id: '',
      list_periode: [],
      periode_id: '',
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    // FormGroup,
    // TabbedPane,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    TrackingTimeline,
    FormGroup,
    // InputForm,
  },
  methods: {
    moment,
    async getData() {
      this.status_result = [];
      this.tracking_status_data = null;

      // this.$store.state.loading = true;
      await TrackingKpiApi.getByParam({
        // employee_id: '7cc8bf35-2bf9-48db-a752-f061eee026c0',
        // periode_id: '90e1f047-97c8-4ca1-80a0-4f0ee227a273',
        employee_id: this.employee_id,
        periode_id: this.periode_id,
      })
        .then((resp) => {
          console.log(resp)

          if (resp?.data) {
            const tracking_status_data = resp?.data?.reverse() || [];
  
            tracking_status_data.forEach((item) => {
              this.status_result.push({
                status: item.status,
                status_str: this.getStatus(item.status),
              });
  
              if (['submission', 'resubmission', 'accept_direct_supervisor', 'revisi_direct_supervisor', 'accept_immediate_supervisor'].includes(item.status)) {
                // this.step_success.push(index)
                this.step_success.push(item.status);
              } else if (['reject_direct_supervisor', 'reject_immediate_supervisor'].includes(item.status)) {
                // this.step_fail.push(index)
                this.step_fail.push(item.status);
              }
            });
            
            if (this.status_result.length === 1) {
              this.status_result.push(...[
                {
                  status: '',
                  status_str: 'Atasan 1',
                },
                {
                  status: '',
                  status_str: 'Atasan 2',
                },
              ]);
  
            } else if (this.status_result.length === 2) {
              this.status_result.push({
                status: '',
                status_str: 'Atasan 2',
              });
            }
  
            this.tracking_status_data = tracking_status_data

            console.log(this.tracking_status_data)
          }
        })
        .catch((err) => {
          console.log(err)
        });
      // this.$store.state.loading = false;
    },
    getStatus(status) {
      const status_list = {
        submission: 'Pengajuan KPI',
        resubmission: 'Pengajuan kembali KPI',
        accept_direct_supervisor: 'Disetujui Atasan 1',
        reject_direct_supervisor: 'Ditolak Atasan 1',
        revisi_direct_supervisor: 'Revisi Atasan 1',
        accept_immediate_supervisor: 'Disetujui Atasan 2',
        reject_immediate_supervisor: 'Ditolak Atasan 2',
      };

      return status_list?.[status] || '-';
    },
    validateField(pattern, str) {
      return pattern.test(str);
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async changePeriode() {
      this.$store.state.loading = true;
      await this.getData();
      this.$store.state.loading = false;
    },
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getSessionUser();
    this.employee_id = this.$store.state?.sessionUser?.employee?.id || '';
    console.log(this.$store.state?.sessionUser);
    await this.getKpiPeriode();
    this.periode_id = this.list_periode?.[0]?.id || '';
    await this.getData();
    this.$store.state.loading = false;

  },
};
</script>

<style scoped>
.box-summary {
  max-width: 800px;
  margin: 0 auto;
}

.box-summary__heading {
  padding-bottom: 12px;
}
.box-summary__list {
  position: relative;
  padding-left: 28px;
  padding-bottom: 32px;
}

.box-summary__list:before {
  position: absolute;
  content: '';
  left: 0;
  top: 6px;
  width: 16px;
  height: 16px;
  border-radius: 100px;
  z-index: 2;
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: inset 0 1px rgba(255, 255, 255, 0.149), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.box-summary__list:after {
  position: absolute;
  content: '';
  left: 8px;
  top: 6px;
  width: 1px;
  height: 100%;
  background-color: #ddd;
  z-index: 1;
}

.box-summary__list:last-child:after {
  display: none;
}

.box-summary a {
  color: blue;
  text-decoration: underline;
  font-size: 13px;
  margin-top: 4px;
}

.box-summary a:hover {
  opacity: 0.7;
} 

.box-summary__status {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
}
.box-summary__status p {
  margin-bottom: 0px;
}
.box-summary__status span {
  display: block;
  width: 4px;
  height: 4px;
  background-color: #7c7c7c;
  border-radius: 100px;
}

.box-summary__status span.date-time {
  font-size: 13px;
} 

</style>